import React, { useState, useEffect } from "react";
import Axios from "./../../utils/api/axiosConf";
import { url } from "../../utils/api/api";
import { RedNotif, GreenNotif, FarsiDate } from "../../utils/utils";
import { Row, Col, Modal } from "antd";
import { color } from "../../utils/themes/color";
import LOADING from "../../components/loading/loading";
import INPUT from "./../../components/input/input";


export default function Dashboard() {




    const [loading, setLoading] = useState({ 1: false, 2: false, 3: false, 4: false });
    const [counter, setCounter] = useState({});
    const [updator, setUpdator] = useState(1)


    useEffect(() => {
        setLoading({ ...loading, 1: true })
        Axios.get(`${url}users/dashboard`)
            .then((response) => {
                if (response.status === 200 || response.status === 201) {
                    setCounter(response.data)
                    setLoading({ ...loading, 1: false })
                }
                else {
                    RedNotif(response.message)
                    setLoading({ ...loading, 1: false })
                }
            })
            .catch((error) => {
                RedNotif("سرور در حال حاضر قادر به پاسخگویی نمی باشد !")
            });

    }, [updator])



    switch (loading[1]) {
        case true: return (
            <div style={{ marginTop: "80px" }}>
                <LOADING type={"lg"} />
            </div>
        )
        case false: return (
            <>
                <Row style={{ marginBottom: '18px' }}>
                    <Col xxl={12} xl={12} lg={12} md={12} sm={12}>
                        <p>آمار تعداد کاربران:</p>
                    </Col>
                </Row>

                <hr color="#1890ff" />

                <Row style={{ marginTop: '68px', marginRight: '8px' }} gutter={20}>
                    <Col xxl={8} xl={8} lg={8} md={8} sm={8}>
                        <div style={{ display: 'flex', padding: "0 12px", marginBottom: '8px' }}>
                            <p>تعداد مربیان:</p>
                        </div>
                        <INPUT
                            value={counter.coachCount}
                        />
                    </Col>
                    <Col xxl={8} xl={8} lg={8} md={8} sm={8}>
                        <div style={{ display: 'flex', padding: "0 12px", marginBottom: '8px' }}>
                            <p>تعداد کاربران دارای اعتبار:</p>
                        </div>
                        <INPUT
                            value={counter.usersWithValidity}
                        />
                    </Col>
                    <Col xxl={8} xl={8} lg={8} md={8} sm={8}>
                        <div style={{ display: 'flex', padding: "0 12px", marginBottom: '8px' }}>
                            <p>تعداد کاربران فاقد اعتبار:</p>
                        </div>
                        <INPUT
                            value={counter.usersWithoutValidity}
                        />
                    </Col>
                </Row>

            </>
        )
    }

}